<template>
  <v-form v-model="check">
    <v-layout justify-center>
      <v-flex>
        <v-card ref="form">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <span> <div>Добавить аттестационное дело соискателя</div></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text v-if="lang.length > 0">

            <v-layout wrap>

              <v-flex md4>
                <v-card-text class="text-xs-left subheading">
                  Фамилия<span class="red--text">*</span>:
                </v-card-text>
                <div v-for="item, i in value.lastName">
                  <v-text-field
                    :error="hasError('lastName')"
                    :error-messages="getError('lastName')"
                    :label=findLang(value.lastName[i].language)
                    required
                    outline
                    v-model="value.lastName[i].text"
                    class="pa-1 ma-1"
                  ></v-text-field>
                </div>
              </v-flex>

              <v-flex md4>
                <v-card-text class="text-xs-left subheading">
                  Имя<span class="red--text">*</span>:
                </v-card-text>
                <div v-for="item, i in value.firstName">
                  <v-text-field
                    :error="hasError('firstName')"
                    :error-messages="getError('firstName')"
                    :label=findLang(value.firstName[i].language)
                    required
                    outline
                    v-model="value.firstName[i].text"
                    class="pa-1 ma-1"
                  ></v-text-field>
                </div>
              </v-flex>

              <v-flex md4>
                <v-card-text class="text-xs-left subheading">
                  Отчество:
                </v-card-text>
                <div v-for="item, i in value.patronymic">
                  <v-text-field
                    :error="hasError('patronymic')"
                    :error-messages="getError('patronymic')"
                    :label=findLang(value.patronymic[i].language)
                    required
                    outline
                    v-model="value.patronymic[i].text"
                    class="pa-1 ma-1"
                  ></v-text-field>
                </div>
              </v-flex>

            </v-layout>
            <v-flex md4>
              <v-text-field
                :error="hasError('birthday')"
                :error-messages="getError('birthday')"
                label= 'Дата рождения'
                required
                type="date"
                outline
                v-model="value.birthday"
                class="pa-1 ma-1"
              > </v-text-field>
            </v-flex>
            <v-layout wrap>



              <v-flex md6>
                <v-card-text class="text-xs-left subheading">
                  Тема диссертационной работы<span class="red--text">*</span>:
                </v-card-text>
                <div v-for="item, i in value.thesisTopic">
                  <v-text-field
                    :error="hasError('thesisTopic')"
                    :error-messages="getError('thesisTopic')"
                    :label=findLang(value.thesisTopic[i].language)
                    required
                    outline
                    v-model="value.thesisTopic[i].text"
                    class="pa-1 ma-1"
                  ></v-text-field>
                </div>
                <v-autocomplete
                  class="pa-1 ma-1"
                  :error="hasError('dissertationCouncil')"
                  :error-messages="getError('dissertationCouncil')"
                  :items="selectors.dissertationCouncil"
                  label="Диссертационный совет"
                  v-model="value.dissertationCouncil"
                  no-data-text="Нет данных"
                ></v-autocomplete>
              </v-flex>
              <v-flex md6>
                <v-autocomplete
                  :error="hasError('language')"
                  :error-messages="getError('language')"
                  :items="lang"
                  v-model="value.language"
                  item-value="id"
                  item-text="name"
                  no-data-text="Нет данных"
                  class="pa-1 ma-1"
                >
                  <span slot="label">Язык защиты<span class="red--text">*</span>:</span>
                </v-autocomplete>
                <v-layout>
                  <v-autocomplete
                    :error="hasError('academicDegree')"
                    :error-messages="getError('academicDegree')"
                    :items="selectors.academicDegree"
                    v-model="value.academicDegree"
                    no-data-text="Нет данных"
                    class="pa-1 ma-1"
                  >
                    <span slot="label">Ученая степень<span class="red--text">*</span>:</span>
                  </v-autocomplete>
                  <v-card-text>{{textAcadem(value.scientificField[0].scientificField)}}</v-card-text>
                </v-layout>


                <v-autocomplete
                  :error="hasError('organization')"
                  :error-messages="getError('organization')"
                  :items="selectors.organization"
                  v-model="value.organization"
                  no-data-text="Нет данных"
                  class="pa-1 ma-1"
                >
                  <span slot="label">Организация, в которой выполнена работа<span class="red--text">*</span>:</span>
                  <template v-slot:prepend-item>
                    <v-list-tile
                      ripple
                      @click="addOrganization = true"
                    >
                      <v-list-tile-action>
                        <v-icon>add</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Добавить новую организацию</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-autocomplete>
              </v-flex>

            </v-layout>

            <v-layout v-for="item, i in  value.scientificField">
              <v-autocomplete
                :error="hasError('scientificField')"
                :error-messages="getError('scientificField')"
                :items="selectors.scientificField"
                v-model="item.scientificField"
                no-data-text="Нет данных"
                class="pa-1 ma-1"
              >
                <span slot="label">Научная специальность (по отраслям науки)<span class="red--text">*</span>:</span>
              </v-autocomplete>

              <v-btn flat icon class="primary" @click="addField('scientificField')">
                <v-icon>add</v-icon>
              </v-btn>
              <v-btn flat icon class="primary" v-if="value.scientificField.length > 1"
                     @click="deleteData(i,'scientificField')">
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
            <v-layout>
              <v-card-text class="text-xs-left title">Добавить научных руководителей:</v-card-text>
              <v-btn flat icon class="primary" @click="addField_scientific_boss">
                <v-icon>add</v-icon>
              </v-btn>
            </v-layout>

            <div v-if="value.scientificBoss !== null">
              <v-layout v-for="item, i in  value.scientificBoss">


                <input @change="setFile($event,'scientificBoss',i,'review')"
                       accept="application/pdf,application/vnd.ms-excel" name="image"
                       :ref="'scientificBossinputUploadFile_'+i"
                       style="font-size: 1.2em; padding: 10px 0;"
                       type="file"
                       v-show="false"/>
                <v-layout wrap>

                  <v-autocomplete
                    class="pa-1 ma-1"
                    :error="hasError('person')"
                    :error-messages="getError('person')"
                    :items="selectors.scientificBoss"
                    label="Научный руководитель"
                    v-model="value.scientificBoss[i].person"
                    no-data-text="Нет данных"
                  >
                    <template v-slot:prepend-item>
                      <v-list-tile
                        ripple
                        @click="addPerson = true"
                      >
                        <v-list-tile-action>
                          <v-icon>add</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>Добавить новое лицо</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-autocomplete>

                  <v-input
                    :error="hasError('scientificBoss')"
                  >
                    Прикрепленный файл отзыв научного руководителя: <a v-if="value.scientificBoss[i].review !==''
                && typeof value.scientificBoss[i].review !== 'object'"
                                                                       :href="value.scientificBoss[i].review"
                                                                       target="_blank" rel="noopener noreferrer">Файл
                    изменений</a>
                    <div
                      v-if="typeof value.scientificBoss[i].review === 'object' && value.scientificBoss[i].review !== null">
                      {{value.scientificBoss[i].review.name}}
                    </div>

                  </v-input>

                  <v-btn v-if="typeof value.scientificBoss[i].review === 'object'
               && value.scientificBoss[i].review !== null" color="primary" flat
                         @click="value.scientificBoss[i].review = null">
                    <v-icon>close</v-icon>
                    Открепить
                  </v-btn>

                  <v-btn v-else @click="$refs['scientificBossinputUploadFile_'+i][0].click()"
                         color="primary"
                         flat>
                    <v-icon>folder_open</v-icon>
                    Прикрепить
                  </v-btn>
                </v-layout>

                <v-btn flat icon class="primary"
                       @click="deleteData(i,'scientificBoss',true)">
                  <v-icon>close</v-icon>
                </v-btn>

              </v-layout>
            </div>

            <v-divider class="pt-2"></v-divider>
            <v-layout>
              <v-card-text class="text-xs-left title">Добавить научных консультантов:</v-card-text>
              <v-btn flat icon class="primary" @click="addField_scientific_consultant">
                <v-icon>add</v-icon>
              </v-btn>
            </v-layout>
            <div v-if="value.scientificConsultant !== null">
              <v-layout v-for="item, i in  value.scientificConsultant">

                <input @change="setFile($event,'scientificConsultant',i,'review')"
                       accept="application/pdf,application/vnd.ms-excel" name="image"
                       :ref="'inputUploadFile_'+i"
                       style="font-size: 1.2em; padding: 10px 0;"
                       type="file"
                       v-show="false"/>
                <v-layout>

                  <v-autocomplete
                    class="pa-1 ma-1"
                    :error="hasError('person')"
                    :error-messages="getError('person')"
                    :items="selectors.scientificBoss"
                    label="Научный консультант"
                    v-model="value.scientificConsultant[i].person"
                    no-data-text="Нет данных"
                  >
                    <template v-slot:prepend-item>
                      <v-list-tile
                        ripple
                        @click="addPerson = true"
                      >
                        <v-list-tile-action>
                          <v-icon>add</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>Добавить новое лицо</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-autocomplete>

                  <v-input
                    :error="hasError('scientificConsultant')"
                    :error-messages="getError('scientificConsultant')"
                  >
                    Прикрепленный файл Научный консультант: <a v-if="value.scientificConsultant[i].review !==''
                && typeof value.scientificConsultant[i].review !== 'object'"
                                                               :href="value.scientificConsultant[i].review"
                                                               target="_blank" rel="noopener noreferrer">Файл
                    изменений</a>
                    <div
                      v-if="typeof value.scientificConsultant[i].review === 'object' && value.scientificConsultant[i].review !== null">
                      {{value.scientificConsultant[i].review.name}}
                    </div>

                  </v-input>

                  <v-btn v-if="typeof value.scientificConsultant[i].review === 'object'
               && value.scientificConsultant[i].review !== null" color="primary" flat
                         @click="value.scientificConsultant[i].review = null">
                    <v-icon>close</v-icon>
                    Открепить
                  </v-btn>

                  <v-btn v-else @click="$refs['inputUploadFile_'+i][0].click()"
                         color="primary"
                         flat>
                    <v-icon>folder_open</v-icon>
                    Прикрепить
                  </v-btn>
                </v-layout>

                <v-btn flat icon class="primary"
                       @click="deleteData(i,'scientificConsultant',true)">
                  <v-icon>close</v-icon>
                </v-btn>

              </v-layout>
            </div>
            <v-divider class="pt-2"></v-divider>
            <div>

              <FileInput
                v-bind:fieldLabel="'заявления'"
                v-bind:field="'statement'"
                v-bind:file=value.statement
                @updateFile="updateFile"
                v-bind:error="hasError('statement')"
                v-bind:error_messages="getError('statement')"
                v-bind:template="setTemplUrl('case.CandidateCase.statement')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'документ об образовании'"
                v-bind:field="'eduDoc'"
                v-bind:file=value.eduDoc
                @updateFile="updateFile"
                v-bind:error="hasError('eduDoc')"
                v-bind:error_messages="getError('eduDoc')"
                v-bind:template="setTemplUrl('case.CandidateCase.eduDoc')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'документ о сдаче кандидатских экзаменов'"
                v-bind:field="'examDoc'"
                v-bind:file=value.examDoc
                @updateFile="updateFile"
                v-bind:error="hasError('examDoc')"
                v-bind:error_messages="getError('examDoc')"
                v-bind:template="setTemplUrl('case.CandidateCase.examDoc')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'заключение организации'"
                v-bind:field="'organizationConclusion'"
                v-bind:file=value.organizationConclusion
                @updateFile="updateFile"
                v-bind:error="hasError('organizationConclusion')"
                v-bind:error_messages="getError('organizationConclusion')"
                v-bind:template="setTemplUrl('case.CandidateCase.organizationConclusion')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'экспертное заключение о возможности открытого опубликования'"
                v-bind:field="'expertPublicationConclusion'"
                v-bind:file=value.expertPublicationConclusion
                @updateFile="updateFile"
                v-bind:error="hasError('expertPublicationConclusion')"
                v-bind:error_messages="getError('expertPublicationConclusion')"
                v-bind:template="setTemplUrl('case.CandidateCase.expertPublicationConclusion')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'экспертное заключение о прохождении экспортного контроля на внешнеэкономическую\n'+
'                сделку'"
                v-bind:field="'expertTradeConclusion'"
                v-bind:file=value.expertTradeConclusion
                @updateFile="updateFile"
                v-bind:error="hasError('expertTradeConclusion')"
                v-bind:error_messages="getError('expertTradeConclusion')"
                v-bind:template="setTemplUrl('case.CandidateCase.expertTradeConclusion')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'согласие на обработку персональных данных'"
                v-bind:field="'personalDataConsent'"
                v-bind:file=value.personalDataConsent
                @updateFile="updateFile"
                v-bind:error="hasError('personalDataConsent')"
                v-bind:error_messages="getError('personalDataConsent')"
                v-bind:template="setTemplUrl('case.CandidateCase.personalDataConsent')"
              ></FileInput>

              <FileInput
                v-bind:fieldLabel="'копия паспорта'"
                v-bind:field="'passport'"
                v-bind:file=value.passport
                @updateFile="updateFile"
                v-bind:error="hasError('passport')"
                v-bind:error_messages="getError('passport')"
                v-bind:template="setTemplUrl('case.CandidateCase.passport')"
              ></FileInput>

            </div>
            <v-dialog @input="loadAddOrganization" v-model="addOrganization" width="500" persistent>
              <Organization @addItem="loadAddOrganization"
                            @ended="addOrganization = false"
                            @refreshItem="loadAddOrganization"
                            v-if="addOrganization"
              >
              </Organization>
            </v-dialog>
            <v-dialog @input="loadAddPerson" v-model="addPerson" width="500" persistent>
              <Person @addItem="loadAddPerson"
                      @ended="addPerson = false"
                      @refreshItem="loadAddPerson"
                      v-if="addPerson"
              >
              </Person>
            </v-dialog>

            <v-btn :loading=loader @click="apply" color="primary" block
                   :disabled="isSendCorrect"
            >Сохранить
            </v-btn>
          </v-card-text>
          <v-progress-circular v-else class="mt-3"
                               :size="70"
                               color="primary"
                               indeterminate
          />
          <v-divider class="mt-5"></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
  </v-form>
</template>


<script>

  import urls from "../../../modules/petition/urls"
  import UserDataFormMixin from '../../../mixins/UserDataFormMixin'
  import {makeGetRequest, makePostRequestFile} from "../../../helper";
  import FileInput from "../../diss/components/FileInput"
  import Person from "../../diss/pages/adminPage/forms/Person"
  import Organization from "../../diss/pages/adminPage/forms/Organization"

  export default {
    name: "CreateApplication",
    mixins: [UserDataFormMixin],
    components: {FileInput, Person, Organization},
    props: {
      id: Number,
      lastName: Array,
      firstName: Array,
      patronymic: Array,
      thesisTopic: Array,
    },


    data() {
      return {

        check: true,
        URL_CREATE: process.env.VUE_APP_API_HOST + "council/admin/case/models/candidate_case/",
        URL_UPDATE: process.env.VUE_APP_API_HOST + "council/admin/case/models/candidate_case/<id>/",
        lang: [],
        loader : false,
        addPerson: false,
        addOrganization: false,
        selectors: {
          academicDegree: [],
          organization: [],
          scientificBoss: [],
          scientificField: [],
          dissertationCouncil: [],
          file_fileds: [],
        },

        value: {
          lastName: [],
          firstName: [],
          patronymic: [],
          thesisTopic: [],
          birthday: null,
          language: null,
          academicDegree: null,
          scientificField: [
            {
              scientificField: null,
            }],
          organization: null,
          scientificBoss: null,
          scientificConsultant: null,
          statement: null,
          eduDoc: null,
          examDoc: null,
          organizationConclusion: null,
          expertPublicationConclusion: null,
          expertTradeConclusion: null,
          personalDataConsent: null,
          passport: null,
          dissertationCouncil: null,
        },

      }
    },
    computed: {
      // геттер вычисляемого значения
      isSendCorrect() {
        let isNotSend = false;
        for (var key in this.value) {
          if ((this.value[key] === undefined || this.value[key] === null)
            && key !== "patronymic"
            && key !== "dissertationCouncil"
            && key !== "scientificConsultant"
            && key !== "scientificBoss"
          ) {
            isNotSend = true;
          }
        }
        return isNotSend
      }
    },
    methods: {
      setTemplUrl(type) {
        let name = this.selectors.file_fileds.filter(function (element) {
          return element.field === type;
        });
        if (name.length === 0)
          return undefined
        else
          return name
      },
      loadAddOrganization() {
        this.addOrganization = false;
        this.selectors.organization = [];
        let url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/organization/"
        this.load(this, url, "organization")
      },
      loadAddPerson() {
        this.addPerson = false;
        this.selectors.scientificBoss = [];
        let url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/person/";
        this.load(this, url, "scientificBoss")
      },
      updateFile(item) {
        this.value[item.field] = item.file;
      },
      setFile(e, field, i = undefined, field_str = undefined) {
        if (i === undefined) {
          const file = e.target.files[0];
          this.value[field] = file;
        } else {
          const file = e.target.files[0];
          this.value[field][i][field_str] = file;
        }

      },
      addField(field) {
        this.value[field].push(
          {
            [field]: null,
          }
        )
      },
      addField_scientific_consultant() {
        if (this.value.scientificConsultant === null)
          this.value.scientificConsultant = []
        this.value.scientificConsultant.push(
          {
            "person": null,
            "review": null,
          }
        )
      },
      addField_scientific_boss() {
        if (this.value.scientificBoss === null)
          this.value.scientificBoss = []
        this.value.scientificBoss.push(
          {
            "person": null,
            "review": null,
          }
        )
      },
      deleteData(idx, key, allDelete = false) {
        if (this.value[key].length > 1 || allDelete)
          this.value[key].splice(idx, 1);
      },

      load: function (app, url, data) {
        if (url === null) {
          app.loadingPage = true;
          return;
        }
        makeGetRequest(url)
          .then(resp => resp.json())
          .then(json => {
            let next_url = null;
            if (json['next'] !== null)
              next_url = url.split('?')[0] + '?' + json['next'].split('?')[1];
            for (let i in json['results']) {
              app.selectors[data].push(Object.assign({}, json['results'][i]));
            }
            app.load(app, next_url, data);
          });
      },
      loadSelector(data, url) {
        let sys = true
        makeGetRequest(url).then(resp => {
          if (!resp.ok) {
            sys = false
          }
          return resp.json()
        }).then(json => {
          this.selectors[data] = json
        })
      },

      text: item => item.name[0].text,
      textAcadem() {
        if (this.value.scientificField[0].scientificField === null) {
          return "";
        } else {
          var lists = this.value.scientificField
          let name = ""
          for (let str in lists) {
            name = this.selectors.scientificField.find(x => x.value === lists[str].scientificField);
          }
          if (name !== undefined) {
            let patt = /\(([^\(\)]+)\)/gmi;
            let pp = patt.exec(name.text);
            return pp[1];
          }
          return " ";
        }
      },

      findLang(langid) {
        let str = this.lang.find(x => x.id === langid).name;
        return str
      },
      closeDialog() {
        this.$emit('ended', '')
      },
      apply: function () {
        this.loader  = true;
        let url = this.URL_CREATE;
        let method = 'POST'

        if (this.id !== undefined) {
          method = 'PUT'
          url = this.URL_UPDATE.replace('<id>', this.id);
        }

        let data = Object.assign({}, this.value);

        var formData = new FormData();

        for (var key in data) {
          if (data[key] !== undefined && data[key] !== null)
            if (key === "lastName" || key === "firstName" || key === "patronymic" //json формируем и отправляем
              || key === "thesisTopic"
            ) {
              let param = data[key];
              let loadFlag = true
              for (var i in param) {
                if (param[i].text === '') {
                  loadFlag = false
                }
              }
              if (loadFlag)
                formData.append(key, JSON.stringify(data[key]))
              else
                formData.append(key, JSON.stringify({}))
            } else if (key === "scientificConsultant") {
              var list = data["scientificConsultant"]
              for (let str in list) {
                let name_strperson = "scientificConsultant[" + str + "]person"
                formData.append(name_strperson, list[str].person)
                let name_strreview = "scientificConsultant[" + str + "]review"
                formData.append(name_strreview, list[str].review)
              }
            } else if (key === "scientificBoss") {
              var list = data["scientificBoss"]
              for (let str in list) {
                let name_strperson = "scientificBoss[" + str + "]person"
                formData.append(name_strperson, list[str].person)
                let name_strreview = "scientificBoss[" + str + "]review"
                formData.append(name_strreview, list[str].review)
              }
            } else if (key === "scientificField") {
              var lists = data["scientificField"]
              for (let str in lists) {
                let name_scientific = "scientificField[" + str + "]scientificField"
                formData.append(name_scientific, lists[str].scientificField)
              }

            } else
              formData.append(key, data[key])
        }

        let status = true;
        makePostRequestFile(url, formData, method)
          .then(resp => {
            if (!resp.ok) {
              status = false;
              this.loader  = false;
            }
            return resp.json()
          })
          .then(json => {
            this.loader  = false;
            if (status) {

              this.$router.push({name: 'ProgressApplication', params: {id: json.id}})
            } else {
              // this.$router.push({name:'ListProgressApplications'})
              this.receiveErrors(json);
              if (json.detail) {
                var detail = confirm(json.detail);
              }
              if (json.non_field_errors) {
                var non_field_errors = confirm(json.non_field_errors);
              }
            }

          })

      },
      isEmptyData() {

      },

    },
    created() {
      let url = process.env.VUE_APP_API_HOST + "council/admin/core/models/language/"
      let sys = true
      makeGetRequest(url).then(resp => {
        if (!resp.ok) {
          sys = false
        }
        return resp.json()
      }).then(json => {
        this.lang = json

        if (this.value.lastName.length === 0) {
          for (let key in this.lang) {
            this.value.lastName.push({"text": "", "language": this.lang[key].id})
            this.value.firstName.push({"text": "", "language": this.lang[key].id})
            this.value.patronymic.push({"text": "", "language": this.lang[key].id})
            this.value.thesisTopic.push({"text": "", "language": this.lang[key].id})
          }
        }

        url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/academic_degree/"
        this.loadSelector("academicDegree", url)

        url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/scientific_field/"
        this.loadSelector("scientificField", url)

        url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/organization/"
        this.load(this, url, "organization")

        url = process.env.VUE_APP_API_HOST + "council/admin/core/selectors/person/"
        this.load(this, url, "scientificBoss")

        this.$store.commit('mainpage/changeTitle', 'Создать заявку');

        url = process.env.VUE_APP_API_HOST + "council/admin/diss/selectors/dissertation_council/"
        this.loadSelector("dissertationCouncil", url)

        url = urls.getUrl('admin|core|models|document_template-list', 'list'),
          this.load(this, url, "file_fileds")


      })
    }
  }

</script>

<style scoped>

</style>
